import React, { Component } from 'react';
import { Table } from 'antd';
import { getMyReward } from "@/api/rewardMessage";

const columns = [{
  title: '邀请用户手机号',
  dataIndex: 'phone',
  width: 250,
}, {
  title: '订购时间',
  dataIndex: 'ctime',
  width: 250,
}, {
  title: '订购服务',
  dataIndex: 'commercialPackageType',
  width: 300,
}, {
  title: '奖励金额（元）',
  dataIndex: 'rebateAmount',
}];

const packageData ={ SITE_ADVANCED:'站点高级版', VOTE_PLATINUM: '投票白金版', VOTE_DIAMOND: '投票钻石版', SITE_EXCLUSIVE:'站点尊享版' , APP_ADVANCED: '小程序小程序企业展示板' };
const packageDateData = {YEAR: '包年' , MONTH: '包月' }

class RewardTable extends Component{
  constructor() {
    super();
    this.state = {
      myRewarddata: [],
    }
  }

  componentDidMount() {
    getMyReward().then(message => {
        this.setState({
          myRewarddata: message,
        })
    });
  }

  get RewardData() {
    return this.state.myRewarddata && this.state.myRewarddata.length > 0 && 
    this.state.myRewarddata.map((item, index) => ( 
      {
          key: index,
          phone: item.phone,
          commercialPackageType: packageData[item.commercialPackageType] + packageDateData[item.durationType] ,
          ctime: new Date(parseInt(item.ctime) * 1000).toLocaleDateString(),
          rebateAmount: item.rebateAmount/100,
      }
    ))
  }

  render() {
      return(
        <React.Fragment>
          <Table columns={columns} dataSource={this.RewardData} pagination={false} scroll={{ y: 240 }} />
        </React.Fragment>
      );
  }
}

export default RewardTable;